<template>
    <div class="modal hide fade in" id="modalEnvio" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{pageTitle}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row" v-if="asignacionSede==undefined && asignacionSede == null">
                        <div class="form-group col-12" id="seleccionUsuarios" >
                            <label>Usuario de Archivo Judicial:</label>
                            <CCuentas
                            v-on:valorParaElPadre="cambioDeUsuarioReceptor" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'catalogoUsuarios'" 
                            :parametros={} 
                            :valorDefinido="parametros_UsuarioReceptor.usuarioId" 
                            
                            :areaConsultaId="AreaDeUsuarios"
                            ></CCuentas>
                        </div>
                    </div>
                     <div class="row" v-else>
                         <div class="form-group col-12">
                            <label>Usuario de Archivo</label>
                            <input type="text" id="nombreSede_div" class="form-control" v-model="NombreUsuario" readonly/>
                        </div>
                     </div>
                        <div class="row">
                                <div class="form-group col-12">
                                    <label>Sede de Archivo:</label>
                                    <sedes
                                        v-on:valorParaElPadre="cambioDeSede" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="'filtroDeBusqueda_Area'" 
                                        :parametros="parametros_SedeArchivo" 
                                        :valorDefinido="parametros_SedeArchivo.sedeArchivoId" 
                                        :key="parametros_SedeArchivo.sedeArchivoId"
                                    ></sedes>
                                </div>
                        </div>              
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" id="botonCancelar" >Cancelar</button>
                    <button type="button" class="btn btn-dark" id="botonAceptar" >Aceptar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
export default {
    components:{
        sedes : catalogos.ArchivoJudicial.C012SedesArchivo,
        CCuentas: catalogos.Cuentas.C001Usuario
    },
    props: {
        usuarios: Array,
        asignacionSede: {
            type: Object,
            default: null
        }
    },
    data(){
        return{
            enumeraciones,
            parametros_SedeArchivo:
                {
                    sedeArchivoId: -1
                },
            parametros_UsuarioReceptor:{
                usuarioId: -1,
            },
            AreaDeUsuarios: 21,
            NombreUsuario:""
        }
    },
    methods:{
        Mostrar: function () {
            $('#modalEnvio').modal('show');
            $('#botonCancelar').unbind('click').click(this.ModalClose);
            $('#closeModal').unbind('click').click(this.ModalClose);
            $('#botonAceptar').unbind('click').click(this.AgregarAsignacion);
            },
        ModalClose: function(){
            $('#modalEnvio').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', false);
        },
        cambioDeSede(datos){
            this.parametros_SedeArchivo.sedeArchivoId = parseInt(datos.target.value);
        },
        cambioDeUsuarioReceptor(datos){
            this.parametros_UsuarioReceptor.usuarioId = parseInt(datos.IdUsuario);
            this.parametros_SedeArchivo.sedeArchivoId = -1
        },
        AgregarAsignacion(){
            if(this.ValidarCampos())
            {
                if(this.VerificarUsuario(this.parametros_UsuarioReceptor.usuarioId, this.usuarios)!=true)
                {
                    
                    let peticion= {
                        "AsignaSede":
                        {
                            "AsignacionSedeId":this.asignacionSede!=null ? this.asignacionSede.AsignacionSedeId: 0,
                            "Usuario": {"IdUsuario": this.parametros_UsuarioReceptor.usuarioId},
                            "Sede" : {"SedeArchivoId": this.parametros_SedeArchivo.sedeArchivoId}
                        }
                    }
                    comun.SeEstaCargandoInformacion(true);
                    axios.post(api.conexion + api.ArchivoJudicial.AsignacionSede, peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then(respuesta => {
                        if (respuesta.data.SiHayError){
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            comun.SeEstaCargandoInformacion(false);
                        }
                        else
                        {
                            var mensaje ="";
                                if (this.asignacionSede!=null)
                                {
                                    mensaje ="Se ha modificado la Asignación de sede del Usuario.";
                                }
                                else
                                {
                                    mensaje ="Se ha creado la Asignación de sede del Usuario.";
                                }
                            comun.mensajeDeAlerta(mensaje, null, null);
                            comun.SeEstaCargandoInformacion(false);
                            this.ModalClose()
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(e=> {
                        console.log("No Hay Respuesta del Servidor", e);
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                    });
                    //AsignacionSede
                }
                else
                {
                    comun.mensajeDeAlerta("El Usuario ya esta Definido en una Sede del Archivo", null, null);
                }
            }
        },
        VerificarUsuario(id, lista){
            var conteo = 0;
            
            if(this.asignacionSede==null)
            {
                $.each(lista, function(index, Listado)
                {
                    if(Listado.Usuario.IdUsuario == id)
                    {
                        conteo ++;
                    }
                });
            }
            if(conteo>0)
            {
                return true;
            }
            return false;
        },
        ValidarCampos(){
            if(this.parametros_UsuarioReceptor.usuarioId == -1)
                {
                    { comun.mensajeDeAlerta("Seleccione un Usuario del Archivo.", null, null);
                    return false;}
                };
            if(this.parametros_SedeArchivo.sedeArchivoId== -1)
                {
                    { comun.mensajeDeAlerta("Seleccione una Sede del Archivo", null, null);
                    return false;}
                };
            return true;
        }
    },
    computed:{
        pageTitle(){
            if(this.asignacionSede != null && this.asignacionSede != undefined && this.asignacionSede.AsignacionSedeId >0)
            {return "EDICIÓN DE ASIGNACIÓN EN SEDE DEL ARCHIVO "} else {return "NUEVA ASIGNACIÓN EN SEDE DEL ARCHIVO"} 
        }
    },
    mounted(){
        if(this.asignacionSede!= null && this.asignacionSede!= undefined)
        {
            this.parametros_SedeArchivo.sedeArchivoId = this.asignacionSede.Sede.SedeArchivoId;
            this.parametros_UsuarioReceptor.usuarioId = this.asignacionSede.Usuario.IdUsuario;
            this.NombreUsuario = this.asignacionSede.Usuario.Nombre + " " + this.asignacionSede.Usuario.ApellidoPaterno + " " +this.asignacionSede.Usuario.ApellidoMaterno
        }
        this.Mostrar();
    }
}
</script>
<style scoped>
input[type="text"]:read-only {
    background: #504f54;
  }

input[type="text"]:read-only:focus {
      color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/AddEditAsignacion.vue